import { render, staticRenderFns } from "./home-web.vue?vue&type=template&id=a8042ff0&scoped=true&"
import script from "./home-web.vue?vue&type=script&lang=js&"
export * from "./home-web.vue?vue&type=script&lang=js&"
import style0 from "./home-web.vue?vue&type=style&index=0&id=a8042ff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8042ff0",
  null
  
)

export default component.exports